import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { GETModels, PIPDetailsVM, PIPImplementsVM, PIPStatusVM } from '../../GET_NEW_UI/entities/global/model';
import { DocumentLibraryService } from '../../GET_NEW_UI/services/document-library.service';
import { ProgramImprovementService } from '../../GET_NEW_UI/services/program-improvement.service';
import { PreferencesService } from '../../preferences/preferences.service';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';

@Component({
  selector: 'app-product-improvement-program-search',
  templateUrl: './product-improvement-program-search.component.html',
  styleUrls: ['./product-improvement-program-search.component.scss'],
    providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})

export class ProductImprovementProgramSearchComponent implements OnInit {

  constructor(private _appService: AppService, private _router:Router,
    private _documentLibraryService:DocumentLibraryService,
    private readonly _pref: PreferencesService,
    private _programImprovementService :ProgramImprovementService, ) { }

  modelList:GETModels[]=[]
  modelList_:GETModels[]=[]
  PIPStatusList:PIPStatusVM[]=[]
  SearchResultsList: PIPDetailsVM[]=[]
  PIPImplementsList_:PIPImplementsVM[]=[]
  Selectmodel:number[]=[];
  InputSelectmodel:string
  serialStart:string
  serialEnd:string
  PIPNumber:string
  PIPHeading:string
  startDate:Date 
  endDate:Date
  selectStatus:number
  IsExapand:boolean=false;
  CopymodelList:GETModels[]=[]

  ngOnInit() {
    this._appService.setPageTitle('Search Product Improvement');

    this.getGETModels();
    this.getPIPStatus();
    this._programImprovementService.getAssetAffectedbyPIP().subscribe(res=>{
      console.log(res)
      this.PIPImplementsList_=res
    })
  }
  NavigateToProductImprovementComponent(){
    this._router.navigate(['/product-improvement-program']);
  }


ChangeExpand(sr:PIPDetailsVM){
  sr.IsExpand = !sr.IsExpand
 
}


getGETModels()
{
  this._documentLibraryService.GetGETModelList().subscribe(res=>{
  this.modelList=res
  this. CopymodelList=res
  })
}

getPIPStatus(){
 this._programImprovementService.getPIPStatus().subscribe(res=>{
 this.PIPStatusList=res
 
 })
}


RestFields(){
  
  this.Selectmodel =[];
  this.startDate=null;
  this.endDate=null;
  this.serialStart="";
  this.serialEnd="";
  this.PIPNumber="";
  this.PIPHeading="";
  this.selectStatus=0;
  this.SearchResultsList=[];
  this.endDate = null;
  this.startDate = null;
  this.InputSelectmodel=""
  //this.PIPImplementsList_=[]
  this.modelList = this.CopymodelList

}


searchPIPDetails(){
  let model= new PIPDetailsVM();
  let array=[];
  console.log(this.Selectmodel)
  this.Selectmodel.length>0?array=this.Selectmodel:array;
  model.ModelId = array;
  model.StartDate=this.startDate==undefined?null:this.startDate;
  model.EndDate=this.endDate==undefined?null:this.endDate;
  model.SerialStart=this.serialStart==undefined?"":this.serialStart;
  model.SerialEnd=this.serialEnd==undefined?"":this.serialEnd;
  model.PIPNo=this.PIPNumber==undefined?"":this.PIPNumber;
  model.PIPHeading=this.PIPHeading==undefined?"":this.PIPHeading;
  model.PIPStatusID=this.selectStatus==undefined?0:this.selectStatus;

  console.log("search fileds", model)

  this._programImprovementService.searchPIPDetails(model).subscribe(res=>{
    console.log("resukt", res)
    this.SearchResultsList = res
  })
}

onClickOpenForm(row:PIPDetailsVM) {
  if (row.Id) {
    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/product-improvement-program', row.Id]);
      }else{             
        window.open('/product-improvement-program/' + row.Id, '_blank');
       
      }
  });

  } else {
    
    window.open('/product-improvement-program/');

  }
}

changeModelAutoComplete(event){
  const filterValue = event.target.value.toLowerCase();

  this.modelList = this.CopymodelList.filter(option => option.modelName.toLowerCase().includes(filterValue));
}
getTitle(UserId: number) {
  console.log(" this.modelList.find(u => u.ID === UserId)",  this.modelList.find(u => u.ID === UserId))
  console.log("UserId",UserId)
  console.log("modelList",this.modelList)
  return this.modelList.find(u => u.ID == UserId).modelName;
}

onSelectBuildNO(value) {
  this.Selectmodel=[]
  
  if(value!=undefined){
    this.modelList_=this.modelList.filter(f=>f.modelName==value)
      console.log("t", value)
      let val= this.modelList_[0].ID
     this.Selectmodel.push(val) 
  }
}

}


